export default __webpack_public_path__ + "static/media/logo_tgv_nomad.fec1fa60.svg";